import { authHeader, handleResponse } from 'helpers';
import { apiConstants } from '../constants';
import { queryFilters, queryWhere } from '../helpers/util';
import { userStorage } from 'helpers/user-storage';

export const customerService = {
  downloadTemplate,
  get,
  getAll,
  add,
  addBulk,
  update,
  remove
};

function downloadTemplate() {
  const filename = 'customers.xlsx';
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  var url = apiConstants.getTemplateExcel.replace(':template', filename)
  return fetch(url, requestOptions)
    .then(response => {
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
      });
    });
}

function get(customer_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  if (customer_id)
    var url = apiConstants.getCustomer.replace(':customer_id', customer_id)
  return fetch(url, requestOptions)
    .then(handleResponse);
}

function getAll(limit, page, filters) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  var url = apiConstants.getCustomers;
  var customerfilters = queryFilters(limit, page);
  if (filters) customerfilters = customerfilters.concat('', queryWhere(filters));
  return fetch(`${url}${customerfilters}`, requestOptions)
    .then(handleResponse);
}

function add(customerValues) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(customerValues)
  };

  var url = apiConstants.addCustomer;
  return fetch(`${url}`, requestOptions)
    .then(handleResponse);
}

function addBulk(file) {
  let headers = '';
  let token = userStorage.getToken();
  if (token) { headers = { Authorization: token }; }
  const requestOptions = {
    method: 'POST',
    headers: headers,
    // headers: authHeader(),
    body: (file)
  };

  var url = apiConstants.addBulkCustomers;
  return fetch(`${url}`, requestOptions)
    .then(handleResponse);
}

function update(customer_id, updatedValues) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(updatedValues)
  };
  var url = apiConstants.updateCustomer.replace(':customer_id', customer_id)
  return fetch(url, requestOptions)
    .then(handleResponse);
}

function remove(customer_id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };
  var url = apiConstants.deleteCustomer.replace(':customer_id', customer_id)
  return fetch(url, requestOptions)
    .then(handleResponse);
}
